import { useLocation, Link } from "react-router-dom";
import {
  Box,
  CloseButton,
  Flex,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import NavItem from "./NavItem";
import { linkItems } from "../../utils/linkItems";

const SidebarContent = ({ onClose, ...rest }) => {
  const { pathname } = useLocation();
  return (
    <Box
      transition="0.5s ease"
      bg="kasbon.900"
      borderRight="1px"
      borderRightColor={useColorModeValue("gray.200", "kasbon.900")}
      w={{ base: "full", md: "260px" }}
      pos="fixed"
      h="full"
      {...rest}
    >
      <Flex
        h="20"
        alignItems="center"
        mx="8"
        mt={{ base: 0, md: "10" }}
        justifyContent="space-between"
      >
        <Link to="/">
          <Text fontSize="3xl" fontWeight="bold" color="white">
            Kasbon<Text as="span" color="kasbon.500">Ku.</Text>
          </Text>
        </Link>
        <CloseButton display={{ base: "flex", md: "none" }} onClick={onClose} />
      </Flex>
      <Box
        mt="24px"
        onClick={onClose}
        overflowY="scroll"
        maxH={{
          base: "calc(100vh - 104px)",
          md: "calc(100vh - 104px - 2.5rem)",
        }}
        pb="24px"
        sx={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {linkItems.map((link) => (
          <NavItem
            key={link.name}
            icon={link.icon}
            href={link.href}
            pathname={pathname}
          >
            {link.name}
          </NavItem>
        ))}
      </Box>
    </Box>
  );
};

export default SidebarContent;
